import * as React from "react";
import { ChevronDown } from "lucide-react";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useSelector } from "react-redux";
import { RootState } from "@/store/reducers";
import ZipteamsLogo from '../../../public/icons/new-zipteams-logo.svg'

export function WorkspaceSwitcher({
  activeWorkspace,
  branding,
  handleSelectWorkspace
}: {
  activeWorkspace: string;
  branding: {
    headerText: string;
  };
  handleSelectWorkspace: Function;
}) {
  const { isMobile } = useSidebar();

  const { user: currentUser, allUsers, workspaces } = useSelector(
      (state: RootState) => state.common,
    );
  
    const loggedUserID = currentUser?.id ; 
  
    const logggedUser = allUsers.find((item) => item.user_id === loggedUserID);
    const userWorkspaceIds = logggedUser?.user_map_workspace.map((ws) => ws.workspace_id) || [];
    const filteredWorkspaces = workspaces.filter((ws) => userWorkspaceIds.includes(ws.id));


  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                <ZipteamsLogo />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">
                  {branding.headerText}
                </span>

                {activeWorkspace && (
                    <div className="flex">
                        <span className="truncate text-xs">{activeWorkspace}</span>
                        <ChevronDown className="w-5 h-5 ml-1" />                
                    </div>
                )}
              </div>
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className=" min-w-60 w-fit rounded-lg"
            align="start"
            side={isMobile ? "bottom" : "right"}
            sideOffset={4}
          >
            <DropdownMenuLabel className="text-xs text-muted-foreground">
              Workspaces
            </DropdownMenuLabel>
            <div className="overflow-y-auto max-h-[90vh]" >
                {filteredWorkspaces.map((workspace, index) => (
              <DropdownMenuItem
                key={workspace.id}
                onClick={() => handleSelectWorkspace(workspace)}
                className="gap-2 p-2 cursor-pointer"
              >                
                {workspace.name}
              </DropdownMenuItem>
            ))}
            </div>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
